import axios from "axios";

let cancelToken = null;

const BASE_URL = "/shop/api/v1/promo";
const state = {
    promo_fabric_types: [],
    promo_fabric_names: [],
    promo_fabric_colors: [],
    promo_fabric_quantity: [],
    promo_fabric_styles: [],
    promo_fabric_static_options: {},
    promo_fabric_calculation: {},
    promo_fabric_add_data: {},
    promo_fabric_get_data: {},
};

const getters = {
    promo_fabric_types: state => state.promo_fabric_types,
    promo_fabric_names: state => state.promo_fabric_names,
    promo_fabric_colors: state => state.promo_fabric_colors,
    promo_fabric_quantity: state => state.promo_fabric_quantity,
    promo_fabric_styles: state => state.promo_fabric_styles,
    promo_fabric_static_options: state => state.promo_fabric_static_options,
    promo_fabric_calculation: state => state.promo_fabric_calculation,
    promo_fabric_add_data: state => state.promo_fabric_add_data,
    promo_fabric_get_data: state => state.promo_fabric_get_data,
};

const actions = {
    loadPromoTypes({ commit }) {
        return axios.get(`${BASE_URL}/fabric-types`).then(response => {
            const data = response.data.map(d => ({
                name: d.ProgramDisplayName,
                id: d.ProgramID
            }));
            commit("PROMO_TYPES_LOADED", data);
            return data;
        });
    },
    loadPromoNames({ commit }, type) {
        return axios
            .post(`${BASE_URL}/fabric-names`, { type })
            .then(response => {
                const data = response.data.map(d => ({
                    name: d.Notes,
                    id: d.ITEMIDS
                }));
                commit("PROMO_NAMES_LOADED", data);
                return data;
            });
    },
    loadPromoColors({ commit }, itemId) {
        return axios
            .post(`${BASE_URL}/fabric-colors`, { itemId })
            .then(response => {
                const data = response.data;
                commit("PROMO_COLORS_LOADED", data);
                return data;
            });
    },
    loadPromoTrimNames({ commit }, type) {
        return axios
            .post(`${BASE_URL}/fabric-trim-names`)
            .then(response => {
                const data = response.data;
                return data;
            });
    },
    loadPromoTrimColors({ commit }, itemId) {
        return axios
            .post(`${BASE_URL}/trim-colors`, { itemId })
            .then(response => {
                const data = response.data;
                return data;
            });
    },
    loadPromoQuantity({ commit }, {programId,value}) {
        return axios
            .post(`${BASE_URL}/fabric-quantity`, { programId,value })
            .then(response => {
                const data = response.data;
                commit("PROMO_QUANTITY_LOADED", data);
                return data;
            });
    },
    loadPromoStyles({ commit }, programId) {
        return axios
            .post(`${BASE_URL}/fabric-styles`, { programId })
            .then(response => {
                const data = response.data.map(d => ({
                    id: d.Option_Id,
                    name: d.Option_Text,
                    image: d.image?"/shop/attachments/promo/"+d.image:"/shop/images/rm-sateen-white.jpg",
                }));
                commit("PROMO_STYLES_LOADED", data);
                return data;
            });
    },
    loadPromoStaticOptions({ commit }) {
        return axios.get(`${BASE_URL}/fabric-static-options`).then(response => {
            const data = response.data;
            commit("PROMO_STATIC_OPTIONS_LOADED", data);
            return data;
        });
    },
    loadPromoCalculation({ commit }, data) {
        if (cancelToken !== null) {
            console.log("canceling request");
            cancelToken.cancel();
        }
        cancelToken = axios.CancelToken.source();
        return axios
            .post(`${BASE_URL}/fabric-calculation`, data, {
                cancelToken: cancelToken.token
            })
            .then(response => {
                cancelToken = null;
                const data = response.data;
                commit("PROMO_CALCULATION_LOADED", data);
                return data;
            });
    },
    loadAddData({ commit }, data) {
        return axios
            .post(`${BASE_URL}/fabric-add-data`, data)
            .then(response => {
             
                const data = response.data;
                commit("PROMO_ADD_DATA_LOADED", data);
                return data;
            });
    },
    loadUpdateData({ commit }, data) {
        return axios
            .post(`${BASE_URL}/fabric-update-data`, data)
            .then(response => {
             
                const data = response.data;
                commit("PROMO_ADD_DATA_LOADED", data);
                return data;
            });
    },
    loadGetData({ commit }, id) {
        return axios
            .post(`${BASE_URL}/fabric-get-data`, {id})
            .then(response => {
             
                const data = response.data;
                commit("PROMO_GET_DATA_LOADED", data);
                return data;
            });
    },
    //QuickShip
    loadQuickShipTypes({ commit }) {
        return axios.get(`${BASE_URL}/fabric-qs-types`).then(response => {
            const data = response.data.map(d => ({
                name: d.ProgramDisplayName,
                id: d.ProgramID
            }));
            return data;
        });
    },
    loadQuickShipNames({ commit }, type) {
        return axios
            .post(`${BASE_URL}/fabric-qs-names`, { type })
            .then(response => {
                const data = response.data.map(d => ({
                    name: d.Notes,
                    id: d.ITEMIDS
                }));
                return data;
            });
    },
    loadQuickShipStyles({ commit }, programId) {
        return axios
            .post(`${BASE_URL}/fabric-qs-styles`, { programId })
            .then(response => {
                const data = response.data.map(d => ({
                    id: d.Option_Id,
                    name: d.Option_Text,
                    image: d.image?"/shop/attachments/promo/"+d.image:"/shop/images/rm-sateen-white.jpg",
                }));
                return data;
            });
    },
    loadQuickShipQuantity({ commit }, {programId,value}) {
        return axios
            .post(`${BASE_URL}/fabric-qs-quantity`, { programId,value })
            .then(response => {
                const data = response.data;
                return data;
            });
    },
    loadQuickShipStaticOptions({ commit }) {
        return axios.get(`${BASE_URL}/fabric-qs-static-options`).then(response => {
            const data = response.data;
            return data;
        });
    },
    loadQuickShipAddData({ commit }, data) {
        return axios
            .post(`${BASE_URL}/fabric-qs-add-data`, data)
            .then(response => {
             
                const data = response.data;
                return data;
            });
    },
    loadQuickShipUpdateData({ commit }, data) {
        return axios
            .post(`${BASE_URL}/fabric-qs-update-data`, data)
            .then(response => {
             
                const data = response.data;
                return data;
            });
    },
    loadQuickShipGetData({ commit }, id) {
        return axios
            .post(`${BASE_URL}/fabric-qs-get-data`, {id})
            .then(response => {
             
                const data = response.data;
                return data;
            });
    },
};

const mutations = {
    PROMO_TYPES_LOADED: (state, data) => {
        state.promo_fabric_types = data;
    },
    PROMO_NAMES_LOADED: (state, data) => {
        state.promo_fabric_names = data;
    },
    PROMO_COLORS_LOADED: (state, data) => {
        state.promo_fabric_colors = data;
    },
    PROMO_QUANTITY_LOADED: (state, data) => {
        state.promo_fabric_quantity = data;
    },
    PROMO_STYLES_LOADED: (state, data) => {
        state.promo_fabric_styles = data;
    },
    PROMO_STATIC_OPTIONS_LOADED: (state, data) => {
        state.promo_fabric_static_options = data;
    },
    PROMO_CALCULATION_LOADED: (state, data) => {
        state.promo_fabric_calculation = data;
    },
    PROMO_ADD_DATA_LOADED: (state, data) => {
        state.promo_fabric_add_data = data;
    },
    PROMO_GET_DATA_LOADED: (state, data) => {
        state.promo_fabric_get_data = data;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
